import type { OrganizationPublic } from '@irace/shared';
import { COPY } from '../copy/vi.ts';
import iraceLogo from '../assets/irace-logo.png';

/** Where the platform credit points. */
const IRACE_URL = 'https://irace.vn';

/**
 * §28.1 — the iRace logo appears only on M00. Every other screen carries this
 * muted footer instead, so the organizer's branding owns the screen and the
 * platform stays a credit line.
 *
 * The logo links out to iRace. It opens in a new tab deliberately: a
 * participant reaching this footer is usually mid-check-in, and navigating the
 * tab away would drop them out of a flow whose pending submission lives in
 * this page's IndexedDB.
 */
export function PoweredByFooter({
  organization,
}: {
  /** The organizer behind this event, when the published config names one. */
  organization?: OrganizationPublic | null;
}) {
  return (
    <div className="flex flex-col items-center gap-1 pt-0.5 pb-[env(safe-area-inset-bottom)]">
      {organization ? (
        <span className="text-[11px] text-text-muted/80">
          {organization.website_url ? (
            <a
              href={organization.website_url}
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              {organization.name}
            </a>
          ) : (
            organization.name
          )}
        </span>
      ) : null}
      <div className="flex items-center justify-center gap-2">
        <span className="text-[11px] text-text-muted/80">{COPY.footer.poweredBy}</span>
        <a
          href={IRACE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="opacity-85 transition-opacity hover:opacity-100"
        >
          <img src={iraceLogo} alt="iRace" className="w-13" />
        </a>
      </div>
    </div>
  );
}
